import RequestsService from "./RequestsService.js";

async function getPullRequests(bitbucketUuid) {
    return await RequestsService.get(`PullRequests/${bitbucketUuid}`);
}

export default {
    getPullRequests: getPullRequests,
};
